import {
  EARLY_ACCESS_PATH,
  isValidEmail,
  normalizeEmail,
  sanitizeAttribution,
} from './earlyAccessSignup';

const SIGNUP_RPC = 'submit_early_access_signup';

function isInvalidEmailRpcError(error) {
  if (!error) return false;
  if (error.code === '22023') return true;
  return /invalid_email/i.test(String(error.message || ''));
}

export async function processEarlyAccessRequest(input, { supabase } = {}) {
  if (!supabase || typeof supabase.rpc !== 'function') {
    return { ok: false, status: 500 };
  }

  if (typeof input?.honeypot === 'string' && input.honeypot.trim() !== '') {
    return { ok: true, ignored: true };
  }

  const email = normalizeEmail(input?.email);
  if (!isValidEmail(email)) {
    return { ok: false, status: 400 };
  }

  const attribution = sanitizeAttribution(input?.attribution || {});
  const requestedConsent = Boolean(input?.marketingConsent);

  try {
    const { error } = await supabase.rpc(SIGNUP_RPC, {
      p_email: email,
      p_marketing_consent: requestedConsent,
      p_source_path: attribution.sourcePath || EARLY_ACCESS_PATH,
      p_referrer: attribution.referrer || null,
      p_utm_source: attribution.utm_source || null,
      p_utm_medium: attribution.utm_medium || null,
      p_utm_campaign: attribution.utm_campaign || null,
      p_utm_content: attribution.utm_content || null,
    });

    if (error) {
      if (isInvalidEmailRpcError(error)) {
        return { ok: false, status: 400 };
      }
      return { ok: false, status: 500 };
    }

    return {
      ok: true,
      marketingAcknowledged: requestedConsent,
    };
  } catch {
    return { ok: false, status: 500 };
  }
}
